import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm$gettingList$items;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "title-small"
  }, [_vm._v("Invoice additional fields")]), _c("div", {
    staticClass: "text-smaller"
  }, [((_vm$gettingList$items = _vm.gettingList.items) === null || _vm$gettingList$items === void 0 ? void 0 : _vm$gettingList$items.length) > 0 ? _c("div", {
    staticClass: "mb-2"
  }, _vm._l(_vm.gettingList.items, function (item) {
    return _c("div", {
      key: "item-" + item.id,
      staticClass: "mb-1"
    }, [_vm.updating.isConfiguring && _vm.updating.form.id == item.id ? _c("div", [_c(VForm, {
      staticClass: "subform-bordered",
      model: {
        value: _vm.updating.form.isValid,
        callback: function callback($$v) {
          _vm.$set(_vm.updating.form, "isValid", $$v);
        },
        expression: "updating.form.isValid"
      }
    }, [_c(VTextField, {
      staticClass: "v-text-field",
      attrs: {
        label: "Label",
        autofocus: "",
        rules: [_vm.formRules.mustNotBeEmpty],
        "hide-details": "auto"
      },
      model: {
        value: _vm.updating.form.label,
        callback: function callback($$v) {
          _vm.$set(_vm.updating.form, "label", $$v);
        },
        expression: "updating.form.label"
      }
    }), _c(VTextField, {
      staticClass: "v-text-field",
      attrs: {
        label: "Text",
        rules: [_vm.formRules.mustNotBeEmpty],
        "hide-details": "auto"
      },
      model: {
        value: _vm.updating.form.text,
        callback: function callback($$v) {
          _vm.$set(_vm.updating.form, "text", $$v);
        },
        expression: "updating.form.text"
      }
    }), _c("div", {
      staticClass: "mt-3 flex"
    }, [_c(VBtn, {
      staticClass: "dfwa-btn --small-2 secondary",
      attrs: {
        rounded: "",
        disabled: _vm.updating.isPending
      },
      on: {
        click: function click($event) {
          return _vm.cancelUpdatingForm();
        }
      }
    }, [_c(VIcon, {
      staticClass: "fa fa-times mr-1",
      attrs: {
        size: "0.65rem"
      }
    }), _vm._v(" Cancel ")], 1), _c(VBtn, {
      staticClass: "dfwa-btn --small-2 highlight",
      attrs: {
        rounded: "",
        disabled: !_vm.updating.form.isValid,
        loading: _vm.updating.isPending
      },
      on: {
        click: function click($event) {
          return _vm.saveUpdatingForm();
        }
      }
    }, [_c(VIcon, {
      staticClass: "fa fa-save mr-1",
      attrs: {
        size: "0.65rem"
      }
    }), _vm._v(" Save ")], 1)], 1)], 1)], 1) : _c("div", {
      staticClass: "flex"
    }, [_c("div", [_vm._v(" · "), _c("span", [_vm._v(_vm._s(item.label) + " :")]), _c("span", {
      staticClass: "ml-1"
    }, [_vm._v(_vm._s(item.text))])]), _c("div", {
      staticClass: "flex gap-2 ml-3"
    }, [_c(VIcon, {
      staticClass: "fa fa-pen text-sm",
      attrs: {
        disabled: _vm.isAnyActionInProgress || _vm.isAnyFormConfiguring,
        title: "Edit"
      },
      on: {
        click: function click($event) {
          return _vm.startUpdatingForm(item);
        }
      }
    }), _c(VIcon, {
      staticClass: "fa fa-trash text-sm",
      attrs: {
        disabled: _vm.isAnyActionInProgress || _vm.isAnyFormConfiguring,
        title: "Delete"
      },
      on: {
        click: function click($event) {
          return _vm.confirmDelete(item);
        }
      }
    })], 1)])]);
  }), 0) : _vm._e(), _c("div", [_vm.adding.isConfiguring ? _c(VForm, {
    staticClass: "subform-bordered",
    model: {
      value: _vm.adding.form.isValid,
      callback: function callback($$v) {
        _vm.$set(_vm.adding.form, "isValid", $$v);
      },
      expression: "adding.form.isValid"
    }
  }, [_c(VTextField, {
    staticClass: "v-text-field",
    attrs: {
      label: "Label",
      autofocus: "",
      rules: [_vm.formRules.mustNotBeEmpty],
      "hide-details": "auto"
    },
    model: {
      value: _vm.adding.form.label,
      callback: function callback($$v) {
        _vm.$set(_vm.adding.form, "label", $$v);
      },
      expression: "adding.form.label"
    }
  }), _c(VTextField, {
    staticClass: "v-text-field",
    attrs: {
      label: "Text",
      rules: [_vm.formRules.mustNotBeEmpty],
      "hide-details": "auto"
    },
    model: {
      value: _vm.adding.form.text,
      callback: function callback($$v) {
        _vm.$set(_vm.adding.form, "text", $$v);
      },
      expression: "adding.form.text"
    }
  }), _c("div", {
    staticClass: "mt-3 flex"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: "",
      disabled: _vm.adding.isPending
    },
    on: {
      click: function click($event) {
        return _vm.cancelAddingForm();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-times mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Cancel ")], 1), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 highlight",
    attrs: {
      rounded: "",
      disabled: !_vm.adding.form.isValid,
      loading: _vm.adding.isPending
    },
    on: {
      click: function click($event) {
        return _vm.saveAddingForm();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-save mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Add ")], 1)], 1)], 1) : _vm._e(), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      disabled: _vm.isAnyActionInProgress || _vm.isAnyFormConfiguring,
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.startAddingForm();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-plus mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Add field ")], 1)], 1)]), _c("Confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };